const buildDate = {"buildDate": "Thu Mar 31 2022 15:39:36 GMT+0300 (Eastern European Summer Time)"};export default buildDate;
